module.exports = __webpack_public_path__ + "56eeefcabbad504900683b9829671e0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/normal/icon_mod_bx.png
// module id = 105
// module chunks = 28